import { createCollection } from '@tanstack/db';
import { queryCollectionOptions } from '@tanstack/query-db-collection';

import { getOthHoofdstukReservering } from '@/api/generated/digiVAPI';
import { queryClient } from '@/services/queryClient';
import { fetchAllPages } from '@/utils/fetchAllPages';

type HoofdstukReserveringCollection = ReturnType<
  typeof createHoofdstukReserveringCollection
>;

export const HOOFDSTUK_RESERVERING_COLLECTION_QUERY_KEY = [
  'hoofdstuk-reservering-collection',
] as const;

export const hoofdstukReserveringCollections = new Map<
  string,
  HoofdstukReserveringCollection
>();

export const refetchHoofdstukReserveringCollections = () =>
  Promise.all(
    [...hoofdstukReserveringCollections.values()].map((collection) =>
      collection.utils.refetch()
    )
  );

export const getHoofdstukReserveringCollection = ({
  besluitLineageId,
}: {
  besluitLineageId: string;
}) => {
  const collection = hoofdstukReserveringCollections.get(besluitLineageId);

  if (collection) return collection;

  const newCollection = createHoofdstukReserveringCollection({
    besluitLineageId,
  });

  hoofdstukReserveringCollections.set(besluitLineageId, newCollection);

  return newCollection;
};

const createHoofdstukReserveringCollection = ({
  besluitLineageId,
}: {
  besluitLineageId: string;
}) => {
  return createCollection(
    queryCollectionOptions({
      id: `hoofdstuk-reservering-collection-${besluitLineageId}`,
      queryClient,
      queryKey: [
        ...HOOFDSTUK_RESERVERING_COLLECTION_QUERY_KEY,
        besluitLineageId,
      ],
      getKey: (item) => item.ID,
      queryFn: async () => {
        const response = await fetchAllPages((page) =>
          getOthHoofdstukReservering({
            page,
            size: 100,
            filter: [
              {
                model: 'HoofdstukLineage',
                field: 'Besluit_lineage',
                op: 'eq',
                value: besluitLineageId,
              },
            ],
          })
        );

        return response;
      },
    })
  );
};
